<template>
    <div>
        <b-tabs :nav-class="tabsNavClass">
            <b-tab title="Court Orders" v-if="canViewCourtOrders" v-on:click="tabActivated(court)">
                <filter-ui :fields="court.filterFields" ref="reportCourtFilter" :apiBaseUrl="apiBaseUrl" relatedTo="report-order-court" :filter="court.initialFilter"  v-on:change="courtFilterChanged"></filter-ui>
                <ejs-grid id="ordersReportCourtGrid"
                          ref="reportCourtGrid"
                          :dataSource="court.gridData"
                          :enableStickyHeader="true"
                          :toolbar="toolbar"
                          :allowExcelExport="true"
                          :allowSorting="true"
                          :sortSettings="court.sortSettings"
                          :allowGrouping="false"
                          :groupSettings="groupSettings"
                          :allowResizing="true"
                          :allowPaging="true"
                          :pageSettings="pageSettings"
                          :excelQueryCellInfo="customiseCell"
                          :showColumnChooser="true"
                          :dataStateChange="reportCourtGridDataStateChanged"
                          :dataBound="reportCourtGridDataBound"
                          :queryCellInfo="customiseCell"
                          :toolbarClick="reportCourtGridToolbarClicked"
                          :created="gridCreated(court)"
                          v-if="court.show"
                          :headerCellInfo="headerCellInfoEvent">
                    <e-columns>
                        <e-column field="epiqReference" headerText="Epiq #" width="100"></e-column>
                        <e-column field="orderNumberDisplayText" headerText="Order Number"></e-column>
                        <e-column field="restricted" :allowSorting="false" :allowGrouping="false" headerText="Restricted Mode"></e-column>
                        <e-column field="orderingClientName" headerText="Ordering Client"></e-column>
                        <e-column field="orderingClientContactName" :allowSorting="false" :allowGrouping="false" headerText="Ordering Client Contact"></e-column>
                        <e-column field="orderingClientContactEmail" :allowSorting="false" :allowGrouping="false" headerText="Ordering Client Contact Email"></e-column>
                        <e-column field="orderingClientContactAddress" :allowSorting="false" :allowGrouping="false" headerText="Ordering Client Contact Address"></e-column>
                        <e-column field="clientReference" headerText="Client Reference"></e-column>
                        <e-column field="clientParticipationInMatterDisplayName" :allowSorting="false" :allowGrouping="false" type="string" :headerText="$t('Vue.Grid.Shared.HeaderText.ClientParticipationInMatter')"></e-column>
                        <e-column field="confirmedDateTimeUTC" headerText="Confirmed Date/Time"></e-column>
                        <e-column field="confirmedBy" :allowSorting="false" :allowGrouping="false" headerText="Confirmed By"></e-column>
                        <e-column field="createdDateTimeUTC" headerText="Created Date/Time"></e-column>
                        <e-column field="createdBy" :allowSorting="false" :allowGrouping="false" headerText="Created By"></e-column>
                        <e-column field="orderedDateTimeUTC" headerText="Ordered Date/Time"></e-column>
                        <e-column field="billingClientContactName" :allowSorting="false" :allowGrouping="false" headerText="Billing Contact"></e-column>
                        <e-column field="billingClientContactEmail" :allowSorting="false" :allowGrouping="false" headerText="Billing Contact Email"></e-column>
                        <e-column field="billingClientContactAddress" :allowSorting="false" :allowGrouping="false" headerText="Billing Contact Address"></e-column>
                        <e-column field="serviceTypeName" headerText="Service Type"></e-column>
                        <e-column field="serviceDelayName" headerText="Turnaround"></e-column>
                        <e-column field="courtMatterNumber" :allowSorting="false" :allowGrouping="false" :headerText="$t('Vue.Grid.Shared.HeaderText.MatterNumber')"></e-column>
                        <e-column field="courtMatterNameOrDescription" :headerText="$t('Vue.Grid.Shared.HeaderText.MatterNameOrDescription')"></e-column>
                        <e-column field="additionalCourtMatters" :allowSorting="false" :allowGrouping="false" :headerText="$t('Vue.Grid.Shared.HeaderText.AdditionalCourtMatters')"></e-column>
                        <e-column field="courtRegistryName" headerText="Court/Tribunal/Other "></e-column>
                        <e-column field="courtJurisdiction" :allowSorting="false" :allowGrouping="false" headerText="Jurisdiction"></e-column>
                        <e-column field="judges" :allowSorting="false" :allowGrouping="false" headerText="Judge/s"></e-column>
                        <e-column field="feeExempt" :allowSorting="false" :allowGrouping="false" headerText="Fee Exempt"></e-column>
                        <e-column field="nonProductionChargeType" :allowSorting="false" :allowGrouping="false" headerText="Additional Charge Type"></e-column>
                        <e-column field="nonProductionChargeQuantity" :allowSorting="false" :allowGrouping="false" headerText="Additional Charge Quantity"></e-column>
                        <e-column field="nonProductionChargeUnitCost" :allowSorting="false" :allowGrouping="false" headerText="Additional Charge Unit Cost"></e-column>
                        <e-column field="nonProductionChargeTotalCost" :allowSorting="false" :allowGrouping="false" headerText="Additional Charge Total Cost"></e-column>
                        <e-column field="nonProductionChargeChargeable" :allowSorting="false" :allowGrouping="false" headerText="Additional Charge Chargeable"></e-column>
                        <e-column field="nonProductionChargeRelatedToDates" :allowSorting="false" :allowGrouping="false" headerText="Additional Charge Related Dates"></e-column>
                        <e-column field="nonProductionChargeComments" :allowSorting="false" :allowGrouping="false" headerText="Additional Charge Comments"></e-column>
                        <e-column field="additionalComments" :allowSorting="false" :allowGrouping="false" headerText="Billing Information"></e-column>
                        <e-column field="statusDisplayName" :allowSorting="false" :allowGrouping="false" headerText="Status"></e-column>
                        <e-column field="subStatusDisplayName" :allowSorting="false" :allowGrouping="false" headerText="Delivery State"></e-column>
                        <e-column field="businessUnit" :allowSorting="false" :allowGrouping="false" :headerText="$t('Vue.Grid.Shared.HeaderText.BusinessUnit')"></e-column>
                        <e-column field="costCenter" :allowSorting="false" :allowGrouping="false" :headerText="$t('Vue.Grid.Shared.HeaderText.CostCenter')"></e-column>
                        <e-column field="accountNumber" :allowSorting="false" :allowGrouping="false" :headerText="$t('Vue.Grid.Shared.HeaderText.AccountNumber')"></e-column>
                        <e-column field="currency" :allowSorting="false" :allowGrouping="false" :headerText="$t('Vue.Grid.Shared.HeaderText.Currency')"></e-column>
                    </e-columns>
                </ejs-grid>
            </b-tab>
            <b-tab title="Interview Orders" v-if="canViewInterviewOrders" v-on:click="tabActivated(interview)">
                <filter-ui :fields="interview.filterFields" ref="reportInterviewFilter" :apiBaseUrl="apiBaseUrl" relatedTo="report-order-interview" :filter="interview.initialFilter" v-on:change="interviewFilterChanged"></filter-ui>
                <ejs-grid id="ordersReportInterviewGrid"
                          ref="reportInterviewGrid"
                          :dataSource="interview.gridData"
                          :enableStickyHeader="true"
                          :toolbar="toolbar"
                          :allowExcelExport="true"
                          :allowSorting="true"
                          :sortSettings="interview.sortSettings"
                          :allowGrouping="false"
                          :groupSettings="groupSettings"
                          :allowResizing="true"
                          :allowPaging="true"
                          :excelQueryCellInfo="customiseCell"
                          :pageSettings="pageSettings"
                          :showColumnChooser="true"
                          :dataStateChange="reportInterviewGridDataStateChanged"
                          :dataBound="reportInterviewGridDataBound"
                          :queryCellInfo="customiseCell"
                          :toolbarClick="reportInterviewGridToolbarClicked"
                          :created="gridCreated(interview)"
                          v-if="interview.show"
                          :headerCellInfo="headerCellInfoEvent">
                    <e-columns>
                        <e-column field="epiqReference" headerText="Epiq #" width="100"></e-column>
                        <e-column field="orderNumberDisplayText" headerText="Order Number"></e-column>
                        <e-column field="orderingClientName" headerText="Ordering Client"></e-column>
                        <e-column field="orderingClientContactName" :allowSorting="false" :allowGrouping="false" headerText="Ordering Client Contact"></e-column>
                        <e-column field="orderingClientContactEmail" :allowSorting="false" :allowGrouping="false" headerText="Ordering Client Contact Email"></e-column>
                        <e-column field="orderingClientContactAddress" :allowSorting="false" :allowGrouping="false" headerText="Ordering Client Contact Address"></e-column>
                        <e-column field="clientReference" headerText="Client Reference"></e-column>
                        <e-column field="confirmedDateTimeUTC" headerText="Confirmed Date/Time"></e-column>
                        <e-column field="confirmedBy" :allowSorting="false" :allowGrouping="false" headerText="Confirmed By"></e-column>
                        <e-column field="createdDateTimeUTC" headerText="Created Date/Time"></e-column>
                        <e-column field="createdBy" :allowSorting="false" :allowGrouping="false" headerText="Created By"></e-column>
                        <e-column field="orderedDateTimeUTC" headerText="Ordered Date/Time"></e-column>
                        <e-column field="billingClientContactName" :allowSorting="false" :allowGrouping="false" headerText="Billing Contact"></e-column>
                        <e-column field="billingClientContactEmail" :allowSorting="false" :allowGrouping="false" headerText="Billing Contact Email"></e-column>
                        <e-column field="billingClientContactAddress" :allowSorting="false" :allowGrouping="false" headerText="Billing Contact Address"></e-column>
                        <e-column field="serviceTypeName" headerText="Service Type"></e-column>
                        <e-column field="serviceDelayName" headerText="Turnaround"></e-column>
                        <e-column field="interviewOrganisationName" :allowSorting="false" :allowGrouping="false" headerText="Interview Organisation"></e-column>
                        <e-column field="interviewDateTime" headerText="Interview Date/Time"></e-column>
                        <e-column field="interviewLength" :allowSorting="false" :allowGrouping="false" headerText="Interview Length"></e-column>
                        <e-column field="interviewLocation" headerText="Interview Location"></e-column>
                        <e-column field="interviewMatterOrCaseReference" :allowSorting="false" :allowGrouping="false" headerText="Matter/Case Reference"></e-column>
                        <e-column field="interviewers" :allowSorting="false" :allowGrouping="false" headerText="Interviewer/s"></e-column>
                        <e-column field="interviewees" :allowSorting="false" :allowGrouping="false" headerText="Interviewee/s"></e-column>
                        <e-column field="feeExempt" :allowSorting="false" :allowGrouping="false" headerText="Fee Exempt"></e-column>
                        <e-column field="nonProductionChargeType" :allowSorting="false" :allowGrouping="false" headerText="Additional Charge Type"></e-column>
                        <e-column field="nonProductionChargeQuantity" :allowSorting="false" :allowGrouping="false" headerText="Additional Charge Quantity"></e-column>
                        <e-column field="nonProductionChargeUnitCost" :allowSorting="false" :allowGrouping="false" headerText="Additional Charge Unit Cost"></e-column>
                        <e-column field="nonProductionChargeTotalCost" :allowSorting="false" :allowGrouping="false" headerText="Additional Charge Total Cost"></e-column>
                        <e-column field="nonProductionChargeChargeable" :allowSorting="false" :allowGrouping="false" headerText="Additional Charge Chargeable"></e-column>
                        <e-column field="nonProductionChargeRelatedToDates" :allowSorting="false" :allowGrouping="false" headerText="Additional Charge Related Dates"></e-column>
                        <e-column field="nonProductionChargeComments" :allowSorting="false" :allowGrouping="false" headerText="Additional Charge Comments"></e-column>
                        <e-column field="additionalComments" :allowSorting="false" :allowGrouping="false" headerText="Billing Information"></e-column>
                        <e-column field="statusDisplayName" :allowSorting="false" :allowGrouping="false" headerText="Status"></e-column>
                        <e-column field="subStatusDisplayName" :allowSorting="false" :allowGrouping="false" headerText="Delivery State"></e-column>
                        <e-column field="businessUnit" :allowSorting="false" :allowGrouping="false" :headerText="$t('Vue.Grid.Shared.HeaderText.BusinessUnit')"></e-column>
                        <e-column field="costCenter" :allowSorting="false" :allowGrouping="false" :headerText="$t('Vue.Grid.Shared.HeaderText.CostCenter')"></e-column>
                        <e-column field="accountNumber" :allowSorting="false" :allowGrouping="false" :headerText="$t('Vue.Grid.Shared.HeaderText.AccountNumber')"></e-column>
                        <e-column field="currency" :allowSorting="false" :allowGrouping="false" :headerText="$t('Vue.Grid.Shared.HeaderText.Currency')"></e-column>
                    </e-columns>
                </ejs-grid>
            </b-tab>
        </b-tabs>

    </div>
</template>

<script>
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import { GridPlugin, ColumnChooser, Resize, Sort, Group, Page, Toolbar, Search, ExcelExport } from '@syncfusion/ej2-vue-grids'; 
    import { DataManager } from "@syncfusion/ej2-data";
    import axios from 'axios';

    import FilterUI from './FilterUI';

    import ErrorsMixin from '../../mixins/ErrorsMixin';
    import DateTimeMixin from '../../mixins/DateTimeMixin';
    import GridMixins from '../../mixins/GridMixins';

    Vue.use(BootstrapVue);
    Vue.use(GridPlugin)

    //this is required to make the getGroupCaption function available globally and thus within the groupCaptionTemplate
    var ordersReportGrid_vueComponent = null;
    function ordersReportGrid_getGroupCaption(field, headerText, value) {
        return ordersReportGrid_vueComponent.getGroupCaption(field, headerText, value);
    }
    window.ordersReportGrid_getGroupCaption = ordersReportGrid_getGroupCaption;

    export default {
        name: 'OrdersReportGrid',
        mixins: [ErrorsMixin, DateTimeMixin, GridMixins],
        components: {
            'filter-ui': FilterUI,
        },
        provide: {
            grid: [ColumnChooser, Resize, Sort, Group, Page, Toolbar, Search, ExcelExport]
        },
        props: {
            apiBaseUrl: {
                type: String,
                required: true
            },
            pagesBaseUrl: {
                type: String,
                required: true
            },
            canViewCourtOrders: {
                type: Boolean,
                default: false
            },
            canViewInterviewOrders: {
                type: Boolean,
                default: false
            },
            canViewListCourtOrders: {
                type: Boolean,
                default: false
            },
            
            allCourtRegistryOptions: {
                type: Array,
                default: null
            },

            allInterviewOrganisationOptions: {
                type: Array,
                default: null
            },

            allOrderingClientOptions: {
                type: Array,
                default: null
            },
            allServiceTypeOptions: {
                type: Array,
                default: null
            },
            allServiceDelayOptions: {
                type: Array,
                default: null
            },
            allOrderStatusOptions: {
                type: Array,
                default: null
            },

            courtRelatedWorkItemOptions: {
                type: Array,
                default: null
            },
            initialCourtRelatedWorkItemId: {
                type: String,
                default: null
            },
            interviewRelatedWorkItemOptions: {
                type: Array,
                default: null
            },
            initialInterviewRelatedWorkItemId: {
                type: String,
                default: null
            }
        },
        data: function () {
            return {
                groupSettings: { showGroupedColumn: true, disablePageWiseAggregates: true, captionTemplate: "${ordersReportGrid_getGroupCaption(field, headerText, key)}" },
                pageSettings: { pageSize: 10, pageSizes: [5, 10, 25, 50] },

                court: {
                    name: "court",
                    initialized: false,
                    dataLoaded: false,
                    show: true,
                    filterFields: [
                        {
                            field: "CourtRegistryId",
                            label: "Court/Tribunal/Other",
                            type: "multiselect",
                            options: this.allCourtRegistryOptions,
                            placeholder: "Select Court/Tribunal/Other Values"
                        },
                        {
                            field: "SittingDate",
                            label: "Sitting Date",
                            type: "date",
                            format: "dd/MM/yyyy"
                        },
                        {
                            field: "OrderingClientId",
                            label: "Ordering Client",
                            type: "multiselect",
                            options: this.allOrderingClientOptions,
                            placeholder: "Select Ordering Client"
                        },
                        {
                            field: "OrderedDate",
                            label: "Ordered Date",
                            type: "date",
                            format: "dd/MM/yyyy"
                        },
                        {
                            field: "ServiceTypeId",
                            label: "Service Type",
                            type: "multiselect",
                            options: this.allServiceTypeOptions,
                            placeholder: "Select Service Types"
                        },
                        {
                            field: "CompletedDate",
                            label: "Date Delivered",
                            type: "date",
                            format: "dd/MM/yyyy"
                        },
                        {
                            field: "ServiceDelayId",
                            label: "Turnaround",
                            type: "multiselect",
                            options: this.allServiceDelayOptions,
                            placeholder: "Select Turnaround Values"
                        },
                        {
                            field: "Status",
                            label: "Status",
                            type: "multiselect",
                            options: this.allOrderStatusOptions,
                            placeholder: "Select Status Values"
                        },
                        {
                            field: "WorkItemId",
                            label: "Worksheet",
                            type: "multiselect",
                            options: this.courtRelatedWorkItemOptions
                        },
                        {
                            field: "Restricted",
                            label: "Restricted Mode",
                            type: "boolean",
                            options: [{ value: false, text: "Not Restricted" }, { value: true, text: "Restricted" }]
                        }
                    ],
                    quickFilters: null,
                    initialFilter: null,

                    sortSettings: { columns: [{ field: "effectiveLastUpdateDateTimeUTC", direction: "Descending" }] },
                    gridDataState: {
                        filter: null,
                        search: null,
                        sorted: [{ name: "effectiveLastUpdateDateTimeUTC", direction: "descending" }],
                        group: null,
                        skip: 0,
                        take: 10,
                        requiresCounts: true
                    },
                    gridData: { result: [], count: 0 },
                    grid: null
                },
                interview: {
                    name: "interview",
                    initialized: false,
                    dataLoaded: false,
                    show: true,
                    filterFields: [
                        {
                            field: "InterviewOrganisationId",
                            label: "Organisation",
                            type: "multiselect",
                            options: this.allInterviewOrganisationOptions,
                            placeholder: "Select Organisations"
                        },
                        {
                            field: "InterviewDate",
                            label: "Date of Interview",
                            type: "date",
                            format: "dd/MM/yyyy"
                        },
                        {
                            field: "OrderingClientId",
                            label: "Ordering Client",
                            type: "multiselect",
                            options: this.allOrderingClientOptions,
                            placeholder: "Select Ordering Client"
                        },
                        {
                            field: "OrderedDate",
                            label: "Ordered Date",
                            type: "date",
                            format: "dd/MM/yyyy"
                        },
                        {
                            field: "CompletedDate",
                            label: "Date Delivered",
                            type: "date",
                            format: "dd/MM/yyyy"
                        },
                        {
                            field: "ServiceTypeId",
                            label: "Service Type",
                            type: "multiselect",
                            options: this.allServiceTypeOptions,
                            placeholder: "Select Service Types"
                        },
                        {
                            field: "ServiceDelayId",
                            label: "Turnaround",
                            type: "multiselect",
                            options: this.allServiceDelayOptions,
                            placeholder: "Select Turnaround Values"
                        },
                        {
                            field: "Status",
                            label: "Status",
                            type: "multiselect",
                            options: this.allOrderStatusOptions,
                            placeholder: "Select Status Values"
                        },
                        {
                            field: "WorkItemId",
                            label: "Worksheet",
                            type: "multiselect",
                            options: this.interviewRelatedWorkItemOptions
                        }
                    ],
                    quickFilters: null,
                    initialFilter: null,

                    sortSettings: { columns: [{ field: "effectiveLastUpdateDateTimeUTC", direction: "Descending" }] },
                    gridDataState: {
                        filter: null,
                        search: null,
                        sorted: [{ name: "effectiveLastUpdateDateTimeUTC", direction: "descending" }],
                        group: null,
                        skip: 0,
                        take: 10,
                        requiresCounts: true
                    },
                    gridData: { result: [], count: 0 },
                    grid: null
                },

                currentGrid: null,
                showErrors: false,
                currentErrors: null,
                disableReason: null,

                columnFormats: {
                    interviewDateTime: {
                        type: 'datetime',
                        options: {
                            mode: 'checktimeincludeseconds',
                            outputAsUTC: true
                        }
                    },
                    orderedDateTimeUTC: {
                        type: 'datetime'
                    },
                    createdDateTimeUTC: {
                        type: 'datetime'
                    },
                    confirmedDateTimeUTC: {
                        type: 'datetime'
                    }
                },
            }
        },
        computed: {
            tabsNavClass: function () {
                var tabsNavClass = "border-bottom-0";
                if (!this.canViewCourtOrders || !this.canViewInterviewOrders) tabsNavClass += " d-none";
                return tabsNavClass;
            },
            toolbar: function () {
                var toolbarItems = this.defaultEJ2DataGridToolbarItems();
                return toolbarItems;
            }
        },
        methods: {
            getGroupCaption: function (field, headerText, value) {
                if ((field == "orderedDateTimeUTC") || (field == "createdDateTimeUTC") || (field == "confirmedDateTimeUTC")) value = this.dateTimeDisplayString(value, 'includetime', true, false);
                else if (field == "interviewDateTime") value = this.dateTimeDisplayString(value, 'checktimeincludeseconds', true, true);
                return headerText + ": " + value;
            },
            customizeGroupKeys(groupedDate) {
                groupedDate.forEach(g => {
                    if (g.field && g.key && g.items) {
                        if (g.field == "interviewDateTime") g.key = this.dateTimeDisplayString(g.key, 'checktimeincludeseconds', true, true);
                        else if (g.field == "createdDateTimeUTC") g.key = this.dateTimeDisplayString(g.key, 'includetime', true, false);
                        else if (g.field == "orderedDateTimeUTC") g.key = this.dateTimeDisplayString(g.key, 'includetime', true, false);
                        else if (g.field == "confirmedDateTimeUTC") g.key = this.dateTimeDisplayString(g.key, 'includetime', true, false);
                        this.customizeGroupKeys(g.items);
                    }
                });
            },
            customiseCell: function (args) {
                this.defaultEJ2DataGridQueryCellInfo(args, this.columnFormats);
            },
            
            courtFilterChanged: function (filter) {
                this.filterChanged(this.court, filter);
            },
            reportCourtGridDataStateChanged: function (args) {
                this.gridDataStateChanged(this.court, args);
            },
            reportCourtGridToolbarClicked: function (args) {
                this.toolbarClicked(this.court, args);
            },
            reportCourtGridDataBound: function () {
                this.court.grid.autoFitColumns();
            },
            interviewFilterChanged: function (filter) {
                this.filterChanged(this.interview, filter);
            },
            reportInterviewGridDataBound: function () {
                this.interview.grid.autoFitColumns();
            },
            reportInterviewGridDataStateChanged: function (args) {
                this.gridDataStateChanged(this.interview, args);
            },
            reportInterviewGridToolbarClicked: function (args) {
                this.toolbarClicked(this.interview, args);
            },

            filterChanged: function (relatedTo, filter) {
                relatedTo.gridDataState.filter = filter;
                if (relatedTo.initialized) relatedTo.grid.refresh();
            },
            gridDataStateChanged: function (relatedTo, args) {
                relatedTo.gridDataState.search = args.search;
                relatedTo.gridDataState.sorted = args.sorted;
                relatedTo.gridDataState.group = args.group;
                relatedTo.gridDataState.skip = args.skip;
                relatedTo.gridDataState.take = args.take;
                relatedTo.gridDataState.requiresCounts = args.requiresCounts;
                if (relatedTo.initialized) {
                    relatedTo.grid.showSpinner();
                    this.loadOrders(relatedTo.name, relatedTo.gridDataState)
                        .then(result => {
                            if (result) {
                                relatedTo.gridData = result;
                            }
                        });
                    relatedTo.grid.hideSpinner();
                }
            },
            updateToolbarItems: function (grid, order) {
                this.setToolbarItemState(grid, 'orderactionsseparator', (order != null));
            },
            setToolbarItemState: function (grid, itemClass, enabled) {
                grid.toolbarModule.enableItems([itemClass], enabled);
            },
            toolbarClicked: function (relatedTo, args) {
                if (args.item.id === 'excelexport') {
                    //to properly export all data (and not just the entries displayed on the current page) we have to load everything first
                    //we do this by taking the current grid state (which includes the current filter and search and sort settings)
                    var gridDataState = {
                        ...relatedTo.gridDataState
                    };
                    //but reset the skip and take to 0 which will return everything and unset the requiresCounts cause we are not interseted in the totals
                    gridDataState.requiresCounts = false;
                    gridDataState.skip = 0;
                    gridDataState.take = 0;
                    relatedTo.grid.showSpinner();
                    this.loadOrders(relatedTo.name, gridDataState)
                        .then(result => {
                            //the result is either false if something failed during the axios request, or it will contain the list in the result property which is what we have to pass to the actual export
                            if (result) {
                                var query = relatedTo.grid.getDataModule().generateQuery(true);
                                var groupedData = new DataManager(result.result).executeLocal(query);
                                this.customizeGroupKeys(groupedData);
                                relatedTo.grid.excelExport({ dataSource: groupedData });
                            }
                            relatedTo.grid.hideSpinner();
                        });
                } else if (args.item.id === 'reset') {
                    this.deleteGridSettings(relatedTo.grid)
                        .then(() => {
                            relatedTo.gridDataState.search = "";
                            relatedTo.show = false;
                            Vue.nextTick(() => {
                                relatedTo.show = true;
                                Vue.nextTick(() => {
                                    relatedTo.grid = (relatedTo.name == "court") ? this.$refs.reportCourtGrid.ej2Instances : this.$refs.reportInterviewGrid.ej2Instances;
                                    this.setupGridPersistence(relatedTo.grid);
                                    this.updateToolbarItems(relatedTo.grid, null);
                                    relatedTo.grid.refresh();
                                });
                            });
                        });
                } else
                    this.defaultEJ2DataGridToolbarClickHandler(args, relatedTo.grid);
            },
            

            


            loadOrders: function (relatedToName, gridDataState) {
                var thisGrid = relatedToName == "court" ? this.court.grid : this.interview.grid
                if (gridDataState.filter == null) {
                    thisGrid.localeObj.localeStrings.EmptyRecord = "Apply a filter to see results";
                    return Promise.resolve({ count: 0, result: [] });
                }
                thisGrid.localeObj.localeStrings.EmptyRecord = "No records to display";

                var url = this.apiBaseUrl + '/report/orderlist/' + relatedToName;
                return axios
                    .post(url, JSON.stringify(gridDataState), {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(response => {
                        var gridData = response.data;
                        if (gridData && gridData.result) {
                            gridData.result = gridData.result.map((order) => {
                                //IMPORTANT! ALL date/time properties have to be converted from strings to 'proper' date/time value here
                                if (order.orderedDateTimeUTC) order.orderedDateTimeUTC = this.parseDateTime(order.orderedDateTimeUTC, true, false);
                                if (order.interviewDateTime) order.interviewDateTime = this.parseDateTime(order.interviewDateTime, true, true);
                                return order;
                            });
                        }
                        return gridData;
                    })
                    .catch(ex => {
                        var errors = this.handleAxiosException(ex);
                        this.showErrorsToast(errors);
                        return false;
                    });
            },
            tabActivated: function (relatedTo) {
                if (!relatedTo.dataLoaded) {
                    relatedTo.grid.refresh();
                    relatedTo.dataLoaded = true;
                }
            },
            gridCreated: function (relatedTo) {
                Vue.nextTick(() => {
                    this.defaultEJ2DataGridCreatedHandler(relatedTo.grid);
                });
            }
        },
        mounted: function () {
            ordersReportGrid_vueComponent = this;
            if (this.canViewCourtOrders) {
                this.court.grid = this.$refs.reportCourtGrid.ej2Instances;
                this.setupGridPersistence(this.court.grid);
                this.updateToolbarItems(this.court.grid, null);
                this.$refs.reportCourtFilter.loadQuickFilters()
                    .then(() => {
                        this.court.initialized = true;
                        //this.court.grid.refresh();
                        this.court.dataLoaded = true;
                    });
            }
            if (this.canViewInterviewOrders) {
                this.interview.grid = this.$refs.reportInterviewGrid.ej2Instances;
                this.setupGridPersistence(this.interview.grid);
                this.updateToolbarItems(this.interview.grid, null);
                this.$refs.reportInterviewFilter.loadQuickFilters()
                    .then(() => {
                        this.interview.initialized = true;
                        if (!this.canViewCourtOrders) {
                            //this.interview.grid.refresh();
                            this.interview.dataLoaded = true;
                        }
                    });
            }
        }
    }
</script>